import useSWRMutation from 'swr/mutation';
import { switchAccountRequest, type SwitchAccountRequestParams, type SwitchAccountResponse } from '../requests';

export const useSwitchAccountMutation = () => {
  const { trigger, data, isMutating, error, reset } = useSWRMutation<
    SwitchAccountResponse,
    Error,
    string,
    SwitchAccountRequestParams
  >('switch-account-mutation', (_, { arg }) => switchAccountRequest(arg));

  return {
    switchAccount: trigger,
    switchAccountData: data,
    isSwitching: isMutating,
    switchAccountError: error,
    resetSwitchAccount: reset,
  };
};
